import { darken, makeStyles, Theme } from '@material-ui/core';


export const useEditAlertRuleStyle = makeStyles((theme: Theme) => {
    return {
        panelContent: {
        },

        form: {
            '& > *': {
                width: '100%',
            },
        },

        stepper: {
            width  : '100%',
            padding: 0,
        },

        step: {
        },

        stepLabel: {
            cursor: 'pointer',
        },

        stepContent: {
        },

        stepContentBody: {
            padding   : theme.spacing(2),
            background: darken(theme.palette.background.paper, 0.07),
        },

        stepContentForm: {
            '&:not(:first-child)': {
                marginTop: theme.spacing(3),
            },
        },

        stepTitle: {
            fontWeight: 'bold',
        },

        stepSubtitle: {
            fontWeight: 'bold',
            textAlign : 'center',
            color     : theme.palette.text.primary,
            '& .note' : {
                fontStyle: 'italic',
                color    : theme.palette.error.main,
            },
        },

        formControl: {
        },

        formControlGroup: {
            position    : 'relative',
            padding     : theme.spacing(1.5, 1.5, 2, 1.5),
            borderRadius: theme.spacing(1),
            margin      : theme.spacing(2, 0),

            '& .form-control:not(:last-child)': {
                marginBottom: theme.spacing(2),
            },
        },

        stepContentActionsContainer: {
            display       : 'flex',
            alignItems    : 'center',
            justifyContent: 'space-between',
        },

        stepContentLeftActionsContainer: {
            display       : 'flex',
            alignItems    : 'center',
            justifyContent: 'left',
        },

        stepContentRightActionsContainer: {
            flex          : 1,
            display       : 'flex',
            alignItems    : 'center',
            justifyContent: 'right',
        },

        navButton: {
            fontSize: 'smaller',
            margin  : theme.spacing(0, 0.5),
        },

        allStepsCompletedMessage: {
            fontWeight: 'bold',
        },

        templateMessageNote: {
            fontStyle    : 'italic',
            paddingBottom: theme.spacing(2),
        },
    };
});
